import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#111A15] text-[#F9F9F7] mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
          <div className="lg:col-span-5">
            <div className="inline-block mb-8">
              <img src="/brand/folks-logo-dark.png" alt="Folks Funds" className="h-14 w-auto" />
            </div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#9DB0A3] mb-6">— Values Creating Value</p>
            <h2 className="font-display font-bold tracking-tighter leading-[0.92] text-5xl sm:text-6xl lg:text-7xl">
              Capital,<br />capability,<br /><span className="text-[#C44900]">capacity.</span>
            </h2>
            <p className="text-[#9DB0A3] mt-8 max-w-md text-[15px] leading-relaxed">
              India's first ESG-integrated AIF Category II fund. Building asset-class businesses by integrating proprietary technology with real-world infrastructure.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8 lg:pl-12">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#9DB0A3] mb-4">Explore</p>
              <ul className="space-y-3 text-[14px]">
                <li><Link to="/about" className="hover:text-[#C44900] transition-colors">About</Link></li>
                <li><Link to="/ecosystem" className="hover:text-[#C44900] transition-colors">Ecosystem</Link></li>
                <li><Link to="/philosophy" className="hover:text-[#C44900] transition-colors">Philosophy</Link></li>
                <li><Link to="/team" className="hover:text-[#C44900] transition-colors">Team</Link></li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#9DB0A3] mb-4">Engage</p>
              <ul className="space-y-3 text-[14px]">
                <li><Link to="/careers" className="hover:text-[#C44900] transition-colors">Careers</Link></li>
                <li><Link to="/contact" className="hover:text-[#C44900] transition-colors">Contact</Link></li>
                <li><a href="mailto:info@folksfunds.com" className="hover:text-[#C44900] transition-colors">Press</a></li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#9DB0A3] mb-4">Ecosystem</p>
              <ul className="space-y-3 text-[14px]">
                <li>
                  <a href="https://www.folksmotor.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:text-[#C44900] transition-colors">
                    Folks Motor <ArrowUpRight className="w-3 h-3 opacity-70" />
                  </a>
                </li>
                <li className="flex items-center gap-1 text-[#9DB0A3]">Folks Finance</li>
                <li className="flex items-center gap-1 text-[#9DB0A3]">Folks Funds</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[12px] text-[#9DB0A3] font-mono uppercase tracking-[0.18em]">
          <div>© {new Date().getFullYear()} Folks Funds — AIF Category II · SEBI Registered</div>
          <div className="flex items-center gap-4">
            <span>New Delhi · India</span>
            <span className="w-1 h-1 rounded-full bg-[#9DB0A3]"></span>
            <span>info@folksfunds.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
